import StatusContext from '@nile/banyan/src/Context/StatusContext';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/banyan/src/Pebbles/select';
import {
  AccessControl,
  BackgroundIcon,
  getTranslatedText,
  Icon,
  Loader,
  preFormatForm,
  TEXT_LENGTH,
  ticketStatusConstraints,
  trimInputValues,
  validateForm
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { Check, Plus, Times } from '@styled-icons/fa-solid';
import {
  Button,
  DisplayText,
  Dropdown,
  FormLayout,
  Heading,
  InlineEdit,
  ResourceItem,
  ResourceList,
  TextField,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { cloneDeep } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

function NewTicketStatusForm(props) {
  const { intl } = props;
  const context = useContext(StatusContext);

  const [statusConfiguration, setStatusConfiguration] = useState(
    context?.statusConfiguration || []
  );
  const [allStatuses, setAllStatuses] = useState(context?.allStatuses || []);

  useEffect(() => {
    setAllStatuses(context.allStatuses);
  }, [context.allStatuses]);

  useEffect(() => {
    setStatusConfiguration(context.statusConfiguration);
  }, [context.statusConfiguration]);

  if (context?.loading) return <Loader />;
  // if (error) return <div> Error page </div>;

  const configMap = {
    CREATE: {
      uniqueId: 'CREATE',
      icon: (
        <div className="fx center">
          <SVGIcon name="Add" />
        </div>
      ),
      description: getTranslatedText(
        intl,
        'admin.Ticketstatus.ticketconfig.createmsg'
      ),
      event: getTranslatedText(
        intl,
        'admin.Ticketstatus.ticketconfig.CreationEvent'
      )
    },
    RESOLVE: {
      uniqueId: 'RESOLVE',
      icon: (
        <div className="fx center">
          <SVGIcon name="Resolution" />
        </div>
      ),
      description: getTranslatedText(
        intl,
        'admin.Ticketstatus.ticketconfig.resolvemsg'
      ),
      event: getTranslatedText(
        intl,
        'admin.Ticketstatus.ticketconfig.ResolvedEvent'
      )
    },
    CLOSE: {
      uniqueId: 'CLOSE',
      icon: (
        <div className="fx center">
          <SVGIcon name="Closure" />
        </div>
      ),
      description: getTranslatedText(
        intl,
        'admin.Ticketstatus.ticketconfig.closuremsg'
      ),
      event: getTranslatedText(
        intl,
        'admin.Ticketstatus.ticketconfig.ClosureEvent'
      )
    }
  };

  let inputOptions = allStatuses.map((el) => {
    return {
      ...el,
      value: el.name,
      label: el.name
    };
  });

  const changeStatusConfiguration = (config, value) => {
    let updatedConfig = cloneDeep(statusConfiguration);
    let idx = updatedConfig.findIndex((el) => el.configuration === config);
    if (idx > -1) {
      updatedConfig[idx].status = value;
    } else {
      updatedConfig.push({
        configuration: config,
        status: value
      });
    }
    context.setStatusConfiguration(updatedConfig);
    context.updateContext({
      ...context.value,
      statusConfiguration: updatedConfig.map((el) => {
        return {
          configuration: el.configuration,
          status: {
            id: el.status.id,
            name: el.status.name,
            description: el.status.description
          }
        };
      })
    });
  };

  return (
    <>
      <div>
        <>
          <div className="mb80">
            <Heading element="h2">
              <FormattedMessage id="admin.Ticketstatus.header2" />
            </Heading>
            <TextStyle variation="subdued">
              {getTranslatedText(intl, 'admin.Ticketstatus.header2.label')}
            </TextStyle>
            {Object.keys(configMap).map((config) => {
              let defaultValue = statusConfiguration.find(
                (el) => el.configuration === config
              )?.status;
              if (defaultValue) {
                defaultValue = {
                  ...defaultValue,
                  value: defaultValue.name,
                  label: defaultValue.name
                };
              }
              return (
                <div className="fx actr border mbt20 wm-600 rounded-2px">
                  <div className="config-actions uppercase fx actr opacity5 bold p8 w200 bg-mercury width-180">
                    <div className="mr8">{configMap[config].icon}</div>
                    <div>{configMap[config].event}</div>
                  </div>
                  <div
                    data-qa={configMap[config].event}
                    className="config-meta flex pr-15 pl-15 actr"
                    superid={`${configMap[config].uniqueId}-ticket-status`}
                  >
                    <div className="mr8">{configMap[config].description}</div>
                    <div className="w200">
                      <Dropdown
                        value={defaultValue}
                        //label={item.title}
                        options={inputOptions}
                        onChange={changeStatusConfiguration.bind(this, config)}
                        components={{ IndicatorSeparator, DropdownIndicator }}
                        classNamePrefix="value_selector"
                        formatGroupLabel={formatGroupLabel}
                        menuPlacement="auto"
                        placeholder={getTranslatedText(
                          intl,
                          'admin.Ticketstatus.pl.choose'
                        )}
                        menuPortalTarget={document.body}
                        closeMenuOnScroll={(e) => {
                          return (
                            e.target &&
                            e.target.classList &&
                            !(
                              e.target.classList.value.indexOf('menu-list') > -1
                            )
                          );
                        }}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (base) => ({ ...base, zIndex: 9999 }),
                          singleValue: (base) => ({ ...base, fontWeight: 700 })
                        }}
                        isDisabled={context?.disableEdit}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      </div>
    </>
  );
}

export default injectIntl(NewTicketStatusForm);
